import { z } from "zod";

import { isValidPhone } from "@shared/libs/phone-number";

import { validationPhoneErrorMessages } from "../i18n/validation-error-codes.ts";

const phoneShapeRegExp = /^\+\d{5,15}$/;

export const phoneSchema = z
  .string()
  .regex(phoneShapeRegExp, validationPhoneErrorMessages.invalidFormat.id)
  .refine(isValidPhone, validationPhoneErrorMessages.invalidFormat.id);
